/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

jQuery(document).ready(function ($) {
	var stickyHeaderWidth = 1200,
		stickyHeaderStart = 200,
		headerOffset      = 140, // Height of sticky header
		menuResizeWidth   = 767;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$("#header-a #main-menu, #header-b #main-menu, #header-d #main-menu").argonmenu({
		resizeWidth: menuResizeWidth,
		collapserTitle: "",
		animSpeed: "medium",
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: "&nbsp;",
		expandIcon:
			'<span class="sub-collapser"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M308.7 427.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 393.4 171.3 244.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6l160 160z"/></svg></span>',
		collapseIcon:
			'<span class="sub-collapser"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M308.7 212.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6-6.2 6.2-16.4 6.2-22.6 0L320 246.6 171.3 395.3c-6.2 6.2-16.4 6.2-22.6 0-6.2-6.2-6.2-16.4 0-22.6l160-160z"/></svg></span>',
	});

	$('#main-menu a[href="#"]').click(function () {
		if ($(window).width() <= menuResizeWidth) {
			$(this).parent().find("> .sub-toggle").click();
		}

		return false;
	});

	$("#header-c .nav-icon").click(function () {
		$("body").toggleClass("nav-open");
	});

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $("#header-a, #header-b, #header-c, #header-d");

	function rpjcStickyHeader() {
		var screenSize = $(window).width(),
			scrollTop = $(document).scrollTop(),
			wrapper = $("#wrapper");

		if (screenSize < stickyHeaderWidth) return;

		if (scrollTop > stickyHeaderStart) {
			$(stickyHeader).addClass("stuck");
			$(wrapper).addClass("header-stuck");
		} else {
			$(stickyHeader).removeClass("stuck");
			$(wrapper).removeClass("header-stuck");
		}
	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$(".toggle-search").click(function () {
		$("body").toggleClass("search-open");

		$('.site-search input[type="text"]').focus();

		return false;
	});

	$(".site-search-close").click(function () {
		$("body").toggleClass("search-open");

		return false;
	});

	//--------------------------------------------
	// Sliders
	//--------------------------------------------

	// Default Sliders

	var defaultSliders = document.querySelectorAll(".default-slider .splide");

	defaultSliders.forEach((slider) => {
		new Splide(slider, {
			type: "loop",
			perPage: 1,
			pauseOnFocus: true,
		}).mount();
	});

	// Logo Scrollers

	var logoScrollers = document.querySelectorAll(".section-logos__logos .splide");

	logoScrollers.forEach((slider) => {
		var logoScroller = new Splide(slider, {
			type: "loop",
			gap: 15,
			autoplay: true,
			interval: 2500,
			speed: 1000,
			perPage: 4,
			perMove: 1,
			arrows: false,
			pagination: false,
			breakpoints: {
				480: {
					perPage: 3
				},
				360: {
					perPage: 2
				}
			},
		});

		logoScroller.on("mounted resized", function () {
			if (logoScroller.length <= logoScroller.options.perPage) {
				logoScroller.options.perPage = logoScroller.length;
			}
		});

		logoScroller.mount();
	});

	// Testimonial Scrollers

	var testimonialScrollers = document.querySelectorAll(".section-testimonials .splide");

	testimonialScrollers.forEach((slider) => {

		new Splide(slider, {
			type: "loop",
			fixedWidth: '400px',
			gap: 20,
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 10000,
			speed: 1000,
			pauseOnFocus: true,
			focus: 0,
			breakpoints: {
				500: {
					perPage: 1,
					fixedWidth: false
				}
			}
		}).mount();

	});

	// Section Sliders

	var sectionSliders = document.querySelectorAll(".section-slider .splide");

	sectionSliders.forEach((slider) => {
		new Splide(slider, {
			type: "fade",
			perPage: 1,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 5000,
			speed: 2000,
			pauseOnFocus: true,
		}).mount();
	});

	// Landing Slider

	var landingSlider = document.querySelector("#landing .splide");

	if (landingSlider) {
		const landingSliderSplide = new Splide(landingSlider, {
			type: "fade",
			rewind: true,
			perPage: 1,
			autoplay: true,
			interval: 7000,
			speed: 2000,
			arrows: false,
			pagination: true,
			drag: false,
			pauseOnHover: false,
		});

		landingSliderSplide.on("pagination:updated", function () {
			if (landingSliderSplide.length === 1) {
				$("#landing .splide__pagination").hide();
			} else {
				$("#landing .splide__pagination").show();
			}
		});

		landingSliderSplide.mount();
	}

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$(".lightbox-image").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "image",
	});

	$(".lightbox-image.wp-block-image").magnificPopup({
		delegate: "a",
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "image",
	});

	$(".lightbox-iframe").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "iframe",
		iframe: {
			markup:
				'<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				"</div>",
			patterns: {
				youtube: {
					index: "youtube.com/",
					id: "v=",
					src: "https://www.youtube.com/embed/%id%?autoplay=1",
				},
			},
		},
	});

	$(".lightbox-team").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific rpjc-magnific-team",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "ajax",
		fixedContentPos: true,
		callbacks: {
			ajaxContentAdded: function () {
				$(".close-team-lightbox").click(function (e) {
					e.preventDefault();
					$.magnificPopup.close();
				});
			},
		},
	});

	$(".lightbox-gallery").each(function () {
		var svgRight =
			'<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M427.3 308.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0-6.2-6.2-6.2-16.4 0-22.6L393.4 320 244.7 171.3c-6.2-6.2-6.2-16.4 0-22.6 6.2-6.2 16.4-6.2 22.6 0l160 160z"/></svg>';

		$(this).magnificPopup({
			delegate: "a",
			closeBtnInside: false,
			mainClass: "rpjc-magnific",
			closeMarkup:
				'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
			type: "image",
			closeOnBgClick: false,
			gallery: {
				enabled: true,
				arrowMarkup: '<div class="mfp-arrow mfp-arrow-%dir%">' + svgRight + "</div>",
			},
		});
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$(".accordion .accordion-content").hide();

	var hash = window.location.hash;

	// Check if there's hash tag in the URL
	if (hash.length) {
		var selectedAccordionItem = $("body").find(".accordion .accordion-item" + hash);

		// If yes, open the matching accordion item
		if (selectedAccordionItem.length) {
			var scrollPx =
				$(window).width() >= stickyHeaderWidth ? selectedAccordionItem.offset().top - headerOffset : selectedAccordionItem.offset().top;

			selectedAccordionItem.addClass("selected").find(".accordion-content").show();

			// Perform scroll down
			$("html, body").animate({ scrollTop: scrollPx }, "slow");
		}
	}

	if ("onhashchange" in window) {
		// detect hash url changes
		$(window).on("hashchange", function (e) {
			//hide open accordion
			$(".accordion-item").removeClass("selected");
			$(".accordion-content").hide();

			var hash = window.location.hash;

			var selectedAccordionItem = $("body").find(".accordion .accordion-item" + hash);

			// If yes, open the matching accordion item
			if (selectedAccordionItem.length) {
				var scrollPx =
					$(window).width() >= stickyHeaderWidth ? selectedAccordionItem.offset().top - headerOffset : selectedAccordionItem.offset().top;

				selectedAccordionItem.addClass("selected").find(".accordion-content").show();

				// Perform scroll down
				$("html, body").animate({ scrollTop: scrollPx }, "slow");
			}
		});
	}

	$(".accordion-handle").click(function () {
		var accordion = $(this).parent().parent();

		if ($(".accordion-content").not(":animated")) {
			if ($(this).parent().hasClass("selected")) {
				$(this).next().slideUp(300).end().parent().removeClass("selected");
			} else {
				$(accordion).find(".accordion-item").removeClass("selected");
				$(this).parent().addClass("selected");
				$(accordion).find(".accordion-content").slideUp(300);
				$(this).next().slideDown(300);
			}
		}

		return false;
	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$(".tabbed-content .tab-nav li:first-child").addClass("active");
	$(".tabbed-content .tab-window .tab-panel").not(":first-child").hide();

	// Check if there's hash tag in the URL
	if (hash.length) {
		var selectedTabPanel = $("body").find(".tabbed-content .tab-window " + hash);

		// If yes, open the matching tab item
		if (selectedTabPanel.length) {
			var scrollPx = $(window).width() >= stickyHeaderWidth ? selectedTabPanel.offset().top - headerOffset : selectedTabPanel.offset().top;

			$(".tabbed-content .tab-window .tab-panel").hide();
			$('.tabbed-content .tab-nav li a[href="' + hash + '"]')
				.parent()
				.addClass("active")
				.siblings()
				.removeClass("active");

			selectedTabPanel.show().siblings().hide();

			// Perform scroll down
			$("html, body").animate({ scrollTop: scrollPx }, "slow");
		}
	}

	$(".tabbed-content .tab-nav a").click(function () {
		var target = $(this).attr("href");

		$(this).parent().addClass("active").siblings().removeClass("active");

		$(target).show().siblings().hide();

		return false;
	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$(".scroll-to").click(function () {
		var selected = $(this).attr("href"),
			scrollPx = $(window).width() < stickyHeaderWidth ? $(selected).offset().top - 20 : $(selected).offset().top - headerOffset;

		$("html, body").animate({ scrollTop: scrollPx }, "slow");

		return false;
	});

	// Scroll to top link

	$('a[href="#top"]').click(function () {
		$("html, body").animate({ scrollTop: 0 }, "slow");

		return false;
	});

	$(".scrolldown").click(function () {
		var target = $(this).parent().next(),
			distance;

		if ($(window).width() < stickyHeaderWidth) {
			distance = $(target).offset().top;
		} else {
			distance = $(target).offset().top - headerOffset;
		}

		$("html, body").animate({ scrollTop: distance }, "slow");

		return false;
	});

	//--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$(".responsive-scroll").each(function () {
		var element = $(this),
			scrollWrapper = $("<div />", {
				class: "scrollable",
				html: '<div class="scrollable-inner" />',
			}).insertBefore(element);

		element.data("scrollWrapper", scrollWrapper);
		element.appendTo(scrollWrapper.find("div"));

		if (element.outerWidth() > element.parent().outerWidth()) {
			element.data("scrollWrapper").addClass("has-scroll");
		}

		$(window).on("resize orientationchange", function () {
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data("scrollWrapper").addClass("has-scroll");
			} else {
				element.data("scrollWrapper").removeClass("has-scroll");
			}
		});
	});

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$(".main").fitVids();

	//--------------------------------------------
	// Read More
	//--------------------------------------------

	$(".read-more-content").hide();

	$(".read-more-button a").on("click", function (e) {
		e.preventDefault();

		var readMoreButton = $(this),
			moreText = readMoreButton.attr("data-more"),
			lessText = readMoreButton.attr("data-less");

		$(readMoreButton)
			.parent()
			.next()
			.not(":animated")
			.slideToggle(300, function () {
				if ($(this).is(":visible")) {
					readMoreButton.html(lessText);
				} else {
					readMoreButton.html(moreText);
				}
			});
	});

	//--------------------------------------------
	// Team B
	//--------------------------------------------

	// $(".team-b .person a").click(function (e) {
	// 	e.preventDefault();

	// 	var target = $(this).attr("href");

	// 	$(".person-details").removeClass("active");

	// 	if ($(this).parent().hasClass("active")) {
	// 		$(this).parent().removeClass("active");

	// 		$(target).removeClass("active");
	// 	} else {
	// 		$(this).parent().addClass("active").siblings(".person").removeClass("active");

	// 		$(target).addClass("active");
	// 	}
	// });

	// $(".person-details .close").click(function () {
	// 	$(".team-b .person").removeClass("active");
	// 	$(".team-b .person-details").removeClass("active");
	// });

	//--------------------------------------------
	// Parallax
	//--------------------------------------------

	const stepsParallax = document.querySelectorAll('.section-steps__image-inner img');

	new SimpleParallax(stepsParallax, {

		scale: 1.2,
		orientation: 'down'

	});

	//--------------------------------------------
	// Scroll Reveal
	//--------------------------------------------

	document.querySelectorAll('.landing__intro__text .display, .hero-a__intro__text .display').forEach(el => {

		const words = el.textContent.trim().split(/\s+/);

		el.innerHTML = words
		.map((word, i) => `<span>${word}</span>`)
		.join(' ');
	
	});

	ScrollReveal().reveal('.landing__intro__text .display span, .hero-a__intro__text .display span', {
		
		distance: '20px',
		origin: 'bottom',
		opacity: 0.4,
		duration: 750,
		easing: 'cubic-bezier(.215,.61,.355,1)',
		interval: 100

	});

	ScrollReveal().reveal('.landing__intro__text > *:not(.accordion *):not(.tabbed-content *), .hero-a__intro__text > *:not(.accordion *):not(.tabbed-content *), .section-logos__text > *:not(.accordion *):not(.tabbed-content *), .section-quicklinks-a__text > *:not(.accordion *):not(.tabbed-content *), .section-quicklinks-a__button:not(.accordion *):not(.tabbed-content *), .section-steps__text > *:not(.accordion *):not(.tabbed-content *), .section-testimonials__text > *:not(.accordion *):not(.tabbed-content *), .latest-posts__title h2:not(.accordion *):not(.tabbed-content *), .latest-posts__more:not(.accordion *):not(.tabbed-content *), .cta-a__text > *:not(.accordion *):not(.tabbed-content *), .section-steps-b__text > *:not(.accordion *):not(.tabbed-content *), .image-content-split__lead > *:not(.accordion *):not(.tabbed-content *), .image-content-split__text > div > *:not(.accordion *):not(.tabbed-content *), img.alignright:not(.accordion *):not(.tabbed-content *), img.alignleft:not(.accordion *):not(.tabbed-content *), img.aligncenter:not(.accordion *):not(.tabbed-content *), img.alignnone:not(.accordion *):not(.tabbed-content *), :is(.content-default, .content-narrow, .content-wide) :is(h1, h2, h3, h4, h5, h6, p, ul, ol, li, .btn):not(.accordion *):not(.tabbed-content *)', {
		
		distance: '30px',
		origin: 'bottom',
		opacity: 0,
		duration: 1500,
		delay: 0

	});

	ScrollReveal().reveal('.quick-links-a a, .section-steps__step, .post-style-a, .section-steps-b__step, .arrow-list ul li, .tick-list ul li', {
		
		distance: '30px',
		origin: 'bottom',
		opacity: 0,
		duration: 1500,
		delay: 0,
		interval: 100

	});

});
